<template>
  <el-dialog
    :title="$t('scheduleClassesPage.selectOrg')"
    :visible.sync="dialogVisible"
    width="40%"
  >
    <el-tree
      ref="orgTree"
      :data="chooseOrgInfo.orgs"
      :props="defaultProps"
      node-key="id"
      highlight-current
      @node-click="handleNodeClick"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="_doChooseOrg">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listOrgTree } from '@/api/org/orgApi'

export default {
  name: 'ChooseOrgTree',
  data() {
    return {
      dialogVisible: false,
      chooseOrgInfo: {
        orgs: [],
        orgId: '',
        curOrg: {}
      },
      defaultProps: {
        children: 'children',
        label: 'text'
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._loadChooseOrgs()
    },
    async _loadChooseOrgs() {
      try {
        const params = {
          communityId: getCommunityId()
        }
        const { data } = await listOrgTree(params)
        
        // 纭繚鏁版嵁鏄暟缁勬牸寮
        let treeData = [data]
        
        // 如果返回的是对象而不是数组，尝试提取数组
        if (Array.isArray(treeData)) {
          this.chooseOrgInfo.orgs = treeData
        } else if (treeData && Array.isArray(treeData.children)) {
          this.chooseOrgInfo.orgs = treeData.children
        } else if (treeData && Array.isArray(treeData.data)) {
          this.chooseOrgInfo.orgs = treeData.data
        } else if (treeData && Array.isArray(treeData.list)) {
          this.chooseOrgInfo.orgs = treeData.list
        } else {
          // 濡傛灉閮戒笉鏄暟缁勶紝杞崲涓烘暟缁勬牸寮
          this.chooseOrgInfo.orgs = Array.isArray(treeData) ? treeData : [treeData]
        }
        
        // 纭繚姣忎釜鑺傜偣閮芥湁 children 灞炴т笖涓烘暟缁
        this.processTreeData(this.chooseOrgInfo.orgs)
      } catch (error) {
        console.log('获取组织树失败', error)
        this.chooseOrgInfo.orgs = []
      }
    },
    processTreeData(nodes) {
      if (!Array.isArray(nodes)) return
      
      nodes.forEach(node => {
        // 纭繚姣忎釜鑺傜偣閮芥湁 children 灞炴т笖涓烘暟缁
        if (!node.children) {
          node.children = []
        } else if (!Array.isArray(node.children)) {
          node.children = []
        }
        
        // 閫掑綊澶勭悊瀛愯妭鐐
        if (node.children && node.children.length > 0) {
          this.processTreeData(node.children)
        }
      })
    },
    handleNodeClick(data) {
      this.chooseOrgInfo.curOrg = data
      this.chooseOrgInfo.curOrg.orgId = data.id
    },
    _doChooseOrg() {
      this.$emit('switchOrg', this.chooseOrgInfo.curOrg)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}
</style>

